import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { updateOfferProduct } from "../../../api/offerProduct";
import {
  calculateMinutesFromTime,
  formatInstallationTime,
} from "../../../utils/helpers";
import { alertError, alertSuccess } from "../../../utils/logger";
import LoadingDialog from "./LoadingDialog";

const ChangeOfferProductTimeDialog = (props) => {
  const { title, open, setOpen, data, onSave } = props;
  const [loading, setLoading] = useState(false);
  const [time, setTime] = useState("");

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  useEffect(() => {
    if (open) {
      setTime(formatInstallationTime(data?.def_tiempo_mano_de_obra));
    }
  }, [open, data]);

  function handleClose() {
    setOpen(false);
    setTime("");
  }

  function saveTime() {
    const normalizedTime = calculateMinutesFromTime(time);
    if (normalizedTime === null) {
      alertError({ error: "El tiempo debe tener formato hh:mm:ss." });
      return;
    }

    if (normalizedTime === Number(data?.def_tiempo_mano_de_obra ?? 0)) {
      handleClose();
      return;
    }

    setLoading(true);
    updateOfferProduct(
      data?.producto_id,
      { ...data, def_tiempo_mano_de_obra: normalizedTime },
      loggedUser?.accessToken
    )
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          alertSuccess({
            title: "Guardado",
            customMessage: "Tiempo unitario actualizado con exito",
          });
          if (typeof onSave === "function") {
            onSave(res.data);
          }
          handleClose();
        }
      })
      .catch((error) => {
        alertError({
          error,
          customMessage: "No se ha podido actualizar el tiempo unitario",
        });
      })
      .finally(() => setLoading(false));
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="xs"
        open={open}
        onClose={handleClose}
        aria-labelledby="change-offer-product-time-dialog"
        className="backdrop"
      >
        <DialogTitle id="change-offer-product-time-dialog">
          {title || "Cambiar tiempo unitario"}
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Producto"
            value={data?.descripcion ?? ""}
            InputLabelProps={{ shrink: true }}
            InputProps={{ readOnly: true }}
            margin="normal"
            variant="outlined"
          />
          <TextField
            autoFocus
            fullWidth
            label="Tiempo unitario (hh:mm:ss)"
            value={time}
            onChange={(event) => setTime(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                saveTime();
              }
            }}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            Cancelar
          </Button>
          <Button onClick={saveTime} variant="outlined" color="primary">
            Actualizar
          </Button>
        </DialogActions>
      </Dialog>
      <LoadingDialog open={loading} />
    </>
  );
};

export default ChangeOfferProductTimeDialog;
